/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReportType,
    ReportTypeFromJSON,
    ReportTypeToJSON,
} from '../models';

export interface ApiFileManagerDownloadAncFileStudyProgramIdGetRequest {
    studyProgramId: string;
}

export interface ApiFileManagerDownloadAracisRequestStudyProgramIdGetRequest {
    studyProgramId: string;
}

export interface ApiFileManagerDownloadReportIdGetRequest {
    id: string;
    type?: ReportType;
}

export interface ApiFileManagerUploadAncFileStudyProgramIdPostRequest {
    studyProgramId: string;
    file?: Blob;
}

export interface ApiFileManagerUploadAracisRequestStudyProgramIdPostRequest {
    studyProgramId: string;
    file?: Blob;
}

export interface ApiFileManagerUploadReportIdTypePostRequest {
    id: string;
    type: ReportType;
    file?: Blob;
}

/**
 * 
 */
export class FileManagerApi extends runtime.BaseAPI {

    /**
     */
    async apiFileManagerDownloadAncFileStudyProgramIdGetRaw(requestParameters: ApiFileManagerDownloadAncFileStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiFileManagerDownloadAncFileStudyProgramIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/FileManager/DownloadAncFile/{studyProgramId}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiFileManagerDownloadAncFileStudyProgramIdGet(requestParameters: ApiFileManagerDownloadAncFileStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiFileManagerDownloadAncFileStudyProgramIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFileManagerDownloadAracisRequestStudyProgramIdGetRaw(requestParameters: ApiFileManagerDownloadAracisRequestStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiFileManagerDownloadAracisRequestStudyProgramIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/FileManager/DownloadAracisRequest/{studyProgramId}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiFileManagerDownloadAracisRequestStudyProgramIdGet(requestParameters: ApiFileManagerDownloadAracisRequestStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiFileManagerDownloadAracisRequestStudyProgramIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFileManagerDownloadReportIdGetRaw(requestParameters: ApiFileManagerDownloadReportIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiFileManagerDownloadReportIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/FileManager/DownloadReport/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiFileManagerDownloadReportIdGet(requestParameters: ApiFileManagerDownloadReportIdGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiFileManagerDownloadReportIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFileManagerUploadAncFileStudyProgramIdPostRaw(requestParameters: ApiFileManagerUploadAncFileStudyProgramIdPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiFileManagerUploadAncFileStudyProgramIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/FileManager/UploadAncFile/{studyProgramId}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFileManagerUploadAncFileStudyProgramIdPost(requestParameters: ApiFileManagerUploadAncFileStudyProgramIdPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiFileManagerUploadAncFileStudyProgramIdPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiFileManagerUploadAracisRequestStudyProgramIdPostRaw(requestParameters: ApiFileManagerUploadAracisRequestStudyProgramIdPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiFileManagerUploadAracisRequestStudyProgramIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/FileManager/UploadAracisRequest/{studyProgramId}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFileManagerUploadAracisRequestStudyProgramIdPost(requestParameters: ApiFileManagerUploadAracisRequestStudyProgramIdPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiFileManagerUploadAracisRequestStudyProgramIdPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiFileManagerUploadReportIdTypePostRaw(requestParameters: ApiFileManagerUploadReportIdTypePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiFileManagerUploadReportIdTypePost.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling apiFileManagerUploadReportIdTypePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/FileManager/UploadReport/{id}/{type}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFileManagerUploadReportIdTypePost(requestParameters: ApiFileManagerUploadReportIdTypePostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiFileManagerUploadReportIdTypePostRaw(requestParameters, initOverrides);
    }

}
